import { RootState } from "store/index";
import { UserProfileCardState } from "./slice";

export const selectUserProfileCard = (state: RootState): UserProfileCardState =>
  state.userProfileCard;

export const selectUserProfileCardAnchorEl = (
  state: RootState,
): UserProfileCardState["anchorEl"] => state.userProfileCard.anchorEl;

export const selectUserProfileCardUserId = (
  state: RootState,
): UserProfileCardState["userId"] => state.userProfileCard.userId;

export const selectUserProfileCardIsShowProfileCard = (
  state: RootState,
): UserProfileCardState["isShowProfileCard"] =>
  state.userProfileCard.isShowProfileCard;
